var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon33BlogPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.8a1 1 0 0 1 .6-.94l17.68-7.78a1 1 0 0 1 1.31 1.32l-7.78 17.68a1 1 0 0 1-1.84-.03L9.3 14.38 2.63 11.7a1 1 0 0 1-.63-.9zm9.24 3.05 1.7 4.24 4.68-10.61-6.38 6.37zm4.96-7.79-6.37 6.37-4.25-1.7L16.2 6.06z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0yIDEwLjhhMSAxIDAgMCAxIC42LS45NGwxNy42OC03Ljc4YTEgMSAwIDAgMSAxLjMxIDEuMzJsLTcuNzggMTcuNjhhMSAxIDAgMCAxLTEuODQtLjAzTDkuMyAxNC4zOCAyLjYzIDExLjdhMSAxIDAgMCAxLS42My0uOXptOS4yNCAzLjA1IDEuNyA0LjI0IDQuNjgtMTAuNjEtNi4zOCA2LjM3em00Ljk2LTcuNzktNi4zNyA2LjM3LTQuMjUtMS43TDE2LjIgNi4wNnoiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPg0KPC9zdmc+DQo=";
export { SvgIcon33BlogPaperplane as ReactComponent };